import { BREAKPOINTS } from './constants'

export default {
  breakpoints: BREAKPOINTS,
  color: {
    primary: '#0057ff',
    danger: 'red',
    black: '#111',
  },
  backgroundColor: {
    light: '#fff',
    dark: '#111',
  },
  textColor: {
    light: '#222',
    dark: '#fff',
  },
}

export interface ITheme {
  breakpoints: string | string[]
}



// WEBPACK FOOTER //
// ./src/styles/theme.ts